module.exports = __webpack_public_path__ + "img/profile-icon.7ff74cf7.svg";